// extracted by mini-css-extract-plugin
export default {"CloseButton":"_CloseButton--e52d4","Reversed":"_Reversed--kgrOr","SidebarLogoExpanded":"_SidebarLogoExpanded--zGGJs"};